module.exports = __webpack_public_path__ + "img/about-guido.png?59bd098702c425a3385d7b278d56ef5c";